<template>
    <div>

<!--
    :sort-field="['category', 'type', 'subType', 'variant', 'qty', 'agl', 'isBillable']"
 -->

    <data-table
      ref="assetTable"
      :table-ref="tableRef"

      :title="title"
      :title-heading="titleHeading"
      icon="fa fa-tools"


      :url="'/assets/site/' + (siteId ? siteId : '')
      + (this.ownerId ? '/owner/' + this.ownerId : '')
      + (this.filterCol && this.filterVal ? '/' + this.filterCol + '/' + this.filterVal : '')"

      :fields="fields"

      :hideTop="hideTop"

      :showTitle="showTitle"
      :showSearch="showSearch"
      :showRefresh="showRefresh"

      :options="siteData"

      :searchPlaceholder="searchPlaceholder"
      :add-action="noAdd ? null : isManager('project|maintenance|finance') ? action : null"
      :add-props="noAdd ? null : addPropsData"
      :detail-component="isTelco() ?  null : 'equip-detail-row'"
      @totalChanged="totalChanged">

      <template slot="shortName" slot-scope="props">
        <org-badge :organisation="props.rowData.organisation" />
      </template>

      <template slot="assets" slot-scope="props">
        <el-row :gutter="8" style="padding-right: 1em;">

          <el-col :xs="24" :sm="24" :md="12" :lg="14">
            <!-- eslint-disable-next-line vue/no-v-html -- formatter output, admin-curated catalogue fields. NOTE: if equipment category/type/subType ever become user-editable, this becomes Bug O — convert to v-safe-html. -->
            <span v-html="formatAssetName(props.rowData)" />
            <span class="text-primary" v-if="props.rowData.diameter">&nbsp;| Dia: <b>{{props.rowData.diameter}}</b> &deg;</span>
            <b class="text-success" v-if="props.rowData.agl">&nbsp;| AGL: <b>{{props.rowData.agl}}</b>m.</b>
            <span class="text-warning" v-if="props.rowData.installedOn">&nbsp;| Installed: {{formatDate(props.rowData.installedOn)}}</span>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="10" :align="isDesktop ? 'right' : ''">
            <!-- eslint-disable vue/no-v-html -- formatter output, numeric → <b><sup> ordinal markup -->
            <span v-if="props.rowData.setNo"
            v-html="addSuffix(props.rowData.setNo, true, true, 'Set')">&nbsp;</span>
            <!-- eslint-enable vue/no-v-html -->
            {{formatBillable(props.rowData.isBillable)}}&nbsp;
          </el-col>
        </el-row>

      </template>

    </data-table>

    <div v-if="isTowerCo() && !readOnly && showQrCode && isManager('project|maintenance') && totals > 0" class="bg-primary-lighten-1" style="padding: 0.2em;">
      <el-row>
        <el-col align="center">
          <el-button type="primary" round :icon="icon" @click="qrCodeActions" :disabled="!enabled">&nbsp;{{qrCodeBtn}}</el-button>
        </el-col>
      </el-row>
    </div>

  </div>
</template>


<script>
import Vue from 'vue'

// import kjua from 'kjua'
// import JSZip from 'jszip'

import QrCodeMixins from '@/mixins/QrCodeMixins'
import SiteMixins from '@/mixins/SiteMixins'

import EquipControls from '@/components/assets/EquipControls'
import EquipDetails from '@/components/assets/EquipDetails'
import EquipAction from '@/components/actions/EquipAction'

Vue.component('equip-controls', EquipControls)
Vue.component('equip-detail-row', EquipDetails)

const DEFAULT_ICON = 'fa fa-qrcode'
const DEFAULT_MSG = 'Download QR Codes for Site Equipment'

export default {
  mixins: [SiteMixins, QrCodeMixins],

  components: {
    EquipControls,
    EquipAction
  },

  props: {
    siteId: {
      type: [String, Number],
      required: true
    },

    ownerId: {
      type: Number,
      default: null
    },

    siteData: {
      type: Object,
      default: null
    },

    filterCol: {
      type: String,
      default: null
    },

    filterVal: {
      type: String,
      default: null
    },

    title: {
      type: String,
      default: ''
    },

    titleHeading: {
      type: String,
      default: 'h3'
    },

    tableRef: {
      type: String,
      default: 'equiptable'
    },

    noAdd: {
      type: Boolean,
      default: false
    },

    hideTop: {
      type: Boolean,
      default: false
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    showTitle: {
      type: Boolean,
      default: true
    },

    showQrCode: {
      type: Boolean,
      default: true
    },

    showRefresh: {
      type: Boolean,
      default: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Name, Category, Type, Sub-Type...'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    totalChanged (t) {
      this.totals = t
    },



    formatAssetName (row) {
      return '<b class="text-primary">' +
      (row.qty ? '</b>' + row.qty + ' x ' + row.category +
       (row.type ? ' / ' + row.type : '') +
       (row.subType ? ' / <b>' + row.subType + '</b>' : '') +
       (row.variant ? ' / ' + row.variant : '')
       : '')
    },



    formatBillable (isBill) {
      if (isBill) {
        return 'Billable'
      } else {
        return 'Free'
      }
    },

  },



  data () {
    return {
      totals: 0,
      icon: DEFAULT_ICON,
      qrCodeBtn: DEFAULT_MSG,
      zipFile: null,
      localData: this.siteData,
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: '__slot:shortName',
          title: 'Owner',
          visible: !this.ownerId || this.canAccess('finance')
        },
        {
          name: '__slot:assets',
          title: ''
        },
        {
          name: '__component:equip-controls',
          title: '',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visibla: this.isTowerCo()
        }
      ],
      action: EquipAction,
      addPropsData: {
        siteId: this.siteId,
        ownerId: this.ownerId ? this.ownerId : this.xolasClient().id,
        siteData: this.siteData,
        tableRef: 'equiptable',
        editMode: false,
        readOnly: this.readOnly
      }
    }
  },  // data

  created () {
    this.qrCodeInit(this.siteData, this.rowData, this.ownerId)
  }

}

</script>
